<template>
  <!-- begin #page-container -->
  <div id="page-container" class="">
    <!-- begin login -->
    <div class="login login-with-news-feed">
      <!-- begin news-feed -->
      <div class="news-feed">
        <div class="news-image" style="background-image: url(/beta/static/img/login-bg/Womia_Box_multiple-box-orange.jpg)"></div>
        <div class="news-caption">
          <!-- <h4 class="caption-title"><b>womia</b>.io</h4>
          <p>
            The leading marketplace for medical imaging Applications
          </p> -->
        </div>
      </div>
      <!-- end news-feed -->
      <!-- begin right-content -->
      <div class="right-content">
        <!-- begin login-header -->
        <div class="login-header">
          <div class="brand">
            <router-link :to="{ name: 'Home'}">
              <img src="/beta/static/logo.svg" style="position: relative; top: -4px; width: 40px; height: 40px;">
              <b class="text-womia">womia</b>.box
            </router-link>
            <small>Medical Catalogs Sharing Platform</small>
          </div>
        </div>
        <!-- end login-header -->
        <!-- begin login-content -->
        <div class="login-content">
          <router-view></router-view>
          <hr />
          <p class="text-center text-grey-darker text-inverse">
            &copy;2024 womia.io. All Right Reserved
          </p>
        </div>
        <!-- end login-content -->
      </div>
      <!-- end right-container -->
    </div>
    <!-- end login -->
  </div>
</template>
<script>
import Vuex from 'vuex'

export default {
  name: 'Auth',
  computed: {
    ...Vuex.mapGetters(['isLoading'])
  }
}
</script>
<style>
/* 7.4 Page - Login */
.login {
    margin: -168px 0 0;
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
}
.login label {
    color: #707478;
}
.login .text-inverse {
  font-size: 12px;
}
.login .login-header {
    position: absolute;
    top: -80px;
    left: 50%;
    right: 0;
    width: 450px;
    padding: 0 40px;
    margin-left: -225px;
    font-weight: 300;
}
.login .login-header .brand a {
    padding: 0;
    font-size: 28px;
    color: #2d353c;
    text-decoration: none;
}
.login .login-header .brand .logo {
    border: 20px solid transparent;
    background-image: url(/beta/static/logo.svg);
    background-repeat: no-repeat;
    background-position: center;
    width: 28px;
    height: 28px;
    position: relative;
    font-size: 0;
    margin-right: 10px;
    border-radius: 6px;
    top: -11px;
}
.login .login-header .brand small {
    font-size: 13px;
    font-weight: 400;
    display: block;
    color: #707478;
}
.login .login-header .icon {
    position: absolute;
    right: 40px;
    top: -2px;
    opacity: 0.1;
}
.login .login-header .icon i {
    font-size: 70px;
}
.login .login-content {
    padding: 30px 40px;
    color: #999;
    width: 450px;
    margin: 0 auto;
}

/* 7.13 Page - Login & Register V3 (Added in V1.7) */
.login.login-with-news-feed {
    width: 100%;
    margin: 0;
    padding: 0;
    top: 0;
}
.login.login-with-news-feed .news-feed {
    position: fixed;
    left: 0;
    right: 500px;
    top: 0;
    bottom: 0;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    overflow: hidden;
}
.login.login-with-news-feed .news-image {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.login.login-with-news-feed .news-image img {
    position: absolute;
    right: 0;
    top: 0;
    left: 0;
    bottom: 0;
    max-height: 100%;
    min-width: 100%;
    top: -1960px;
    bottom: -1960px;
    left: -1960px;
    right: -1960px;
    margin: auto;
}
.login.login-with-news-feed .news-caption {
    color: rgba(255, 255, 255, 0.75);
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 60px 60px 30px;
    font-size: 18px;
    z-index: 20;
    font-weight: 300;
    background: -moz-linear-gradient(top, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 100%);
  background: -webkit-linear-gradient(top, rgba(0,0,0,0) 0%,rgba(0,0,0,1) 100%);
  background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#000000',GradientType=0 );
}
.login.login-with-news-feed .news-caption .caption-title {
    color: #fff;
    font-weight: 300;
    font-size: 36px;
}
.login.login-with-news-feed .right-content {
    float: right;
    width: 500px;
}
@media (max-width:450px){
  .login.login-with-news-feed .right-content{
    width: 100%;
  }
  .login.login-with-news-feed .login-content{
    padding:30px 0px 0 80px;
  }
  .login.login-with-news-feed .login-header{
    margin: auto;
    left: auto;
    right: 0;
  }
  .login.login-with-news-feed .login-content{
    width: auto;
  }
}
.login.login-with-news-feed .login-content {
    width: auto;
    padding: 30px 60px;
}
.login.login-with-news-feed .login-header{
    position: relative;
    top: 0;
    margin: 0;
    left: 0;
    right: 0;
    padding: 100px 60px 0;
}
.login.login-with-news-feed .login-header .brand {
    color: #242a30;
}
.login.login-with-news-feed .login-header .brand small {
    color: #707478;
}
.login.login-with-news-feed .login-header .icon {
    top: 98px;
    right: 10px;
}
.login .form-control.form-control-lg, .login .form-control.input-lg {
  font-size: 14px;
  height: 46px;
  padding: 10px 16px;
  line-height: 1.3333333;
  border-radius: 6px;
}
/* custom style */
.invalid-feedback {
  color: #ae2424;
  font-size: 10px;
  padding-left: 18px;
}
.form-control {
    margin: 0px!important;
}
@media (max-width: 450px){
.brand{
  position: relative;
}}
.orange-btn-custom{
  background: #E95913!important;
  color: var(--bs-app-theme-color)!important;
  border-color: transparent!important;
}
.orange-btn-custom:hover{
  background: #E21919!important;
}
.btn-primary get-started  {
  background: #E21919!important;
  color: var(--bs-app-theme-color)!important;
  border-color: transparent!important;
}
.btn-primary get-started :hover{
  background: #E95913!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/auth/AuthLayout.vue